// removed by extract-text-webpack-plugin
module.exports = {"type-changer":"type-changer__type-changer___vv5tP","type":"type-changer__type___2Wq8R","type-changer-pop-up":"type-changer__type-changer-pop-up___13VDo"};